<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="admin.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Код</label>
            <crm-input-text
              [(value)]="admin.code"
              [isError]="$any(errors?.code)"></crm-input-text>
            <small
              *ngIf="errors?.code"
              class="p-error">
              {{ errors.code | join }}
            </small>
          </div>

          <div
            *ngIf="admin['deleted']"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удален"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        styleClass="p-button-success"
        [label]="saveButtonLabel"
        (onClick)="saveAdmin()"></crm-button>

      <ng-container *ngIf="(form$ | async)?.isShowDelete">
        <crm-button
          *ngIf="!admin['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteAdmin()"></crm-button>

        <crm-button
          *ngIf="admin['deleted']"
          label="Восстановить"
          styleClass="p-button-text"
          (onClick)="restoreAdmin()"></crm-button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
